import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import { VTextField } from 'vuetify/lib';

Vue.use(Vuetify, { components: { VTextField } });

import hr from 'vuetify/lib/locale/hr';

Vue.component('my-component', {
	methods: {
		changeLocale() {
			this.$vuetify.lang.current = 'hr';
		},
	},
});

export default new Vuetify({
	icons: {
		iconfont: 'fa',
	},
	lang: {
		locales: { hr },
		current: 'hr',
	},
});
